"use client"; // Error boundaries must be Client Components
import Link from "next/link";
import Image from "next/image";
import GoWrong from "@/app/assets/common/GoWrong.png";
import { Button } from "antd";
import Header from "@/app/components/layout-widgets/header";
import Footer from "@/app/components/layout-widgets/footer/index";
import { RegisterModal } from "@/app/components/common/Register/RegisterModal";
import Search from "@/app/components/layout-widgets/search/index";
import Category from "@/app/components/layout-widgets/category/index";
import { useEffect, useState } from "react";
import { produCtcategoryTree } from "@/service/index";
import { categoryData } from "@/utils/const";
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  // const [categoryData, setCategoryData] = useState<any>(null);

  console.log("error", error);

  // useEffect(() => {
  //   produCtcategoryTree({}).then((res) => {
  //     setCategoryData(res);
  //   });
  // }, []);

  return (
    <>
      <Header />
      <Search data={categoryData} />
      <Category data={categoryData} />
      <div style={{ maxWidth: "var(--max-width)", margin: "0 auto" }}>
        <div
          className="w-160 text-center md:w-200"
          style={{ margin: "140px auto 0" }}
        >
          <Image
            src={GoWrong}
            width={200}
            height={200}
            sizes="100%"
            alt={"gowrong-image"}
          />
        </div>
        <h2 className="text-center font-bold leading-24 text-bravve-100">
          Sorry, the data is wrong
        </h2>
        <p className="mt-4 text-center leading-22 text-bravve-sub-100">
          Try refreshing it again.
        </p>
        <div className="mb-100 text-center">
          <Link href="/">
            <Button type="primary" className="mt-24 w-247">
              Go Home
            </Button>
          </Link>
        </div>
      </div>
      <RegisterModal />
      <Footer />
    </>
  );
}
